import React from "react";
import { processStatisticsPercentage, renderStatistics } from "@/modules/statistics";
import { IGameStatisticsClass } from "@/types/StatisticsTypes";
import { fortyEightDReds } from "@/modules/commonMobile";

export default class M36 extends IGameStatisticsClass {
	constructor() {
		super(null);

		this.filtrate = function(history, filter) {
			const total = history.length;

			switch (filter) {
				case "red-black":
					let red = 0, blacks = 0; //, zeroes = 0;
					history.forEach(item => {
						const angka = Number(item.angka);
						if (fortyEightDReds.indexOf(angka) >= 0 && angka > 0)
							++red;
						else if (angka === 0) return;
							//++zeroes;
						else
							++blacks;
					});
					
					this.statisticsArray.top.push([
						<div key="p6gst_0" className="sl-roadmap-circle red-bg"></div>,
						<div key="p6gst_1" className="sl-roadmap-circle black-bg"></div>
					]);
					
					this.statisticsArray.bottom.push([
						processStatisticsPercentage("p6gsb_0", red, total),
						processStatisticsPercentage("p6gsb_1", blacks, total)
					]);
				break;
				case "odd-even":
					let odds = 0, evens = 0;
					history.forEach(item => {
						const angka = Number(item.angka);
						if (angka % 2)
							++odds;
						else if (!(angka % 2) && angka > 0)
							++evens;
					});
					
					this.statisticsArray.top.push([
						<div key="p6gst_2" className="sl-roadmap-circle blue-bg">O</div>,
						<div key="p6gst_3" className="sl-roadmap-circle red-bg">E</div>
					]);
					
					this.statisticsArray.bottom.push([
						processStatisticsPercentage("p6gsb_2", odds, total),
						processStatisticsPercentage("p6gsb_3", evens, total)
					]);
				break;
				case "small-big":
					let smalls = 0, bigs = 0;
					history.forEach(item => {
						const angka = Number(item.angka);
						if (angka <= 24 && angka > 0)
							++smalls;
						else if (angka > 24)
							++bigs;
					});
					
					this.statisticsArray.top.push([
						<div key="p6gst_4" className="sl-roadmap-circle blue-circle">S</div>,
						<div key="p6gst_5" className="sl-roadmap-circle red-circle">B</div>
					]);
					
					this.statisticsArray.bottom.push([
						processStatisticsPercentage("p6gsb_4", smalls, total),
						processStatisticsPercentage("p6gsb_5", bigs, total)
					]);
				break;
				default: break;
			}
		};
	}

	

	render() {
		return renderStatistics(this);
	}
}
